var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDemand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.81982 5.8584H33.1802V10.972H2.81982V5.8584Z",
    fill: "#636799"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.81982 10.4297H33.1802V31.4759H2.81982V10.4297Z",
    fill: "#737AE6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.81982 10.4297H33.1802V31.4759H2.81982V10.4297Z",
    fill: "white",
    fillOpacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.81982 29.915H33.1802V30.6953H2.81982V29.915Z",
    fill: "#737AE6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.81982 29.915H33.1802V30.6953H2.81982V29.915Z",
    fill: "white",
    fillOpacity: 0.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.81982 30.6953H33.1802V31.4756H2.81982V30.6953Z",
    fill: "#737AE6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.81982 30.6953H33.1802V31.4756H2.81982V30.6953Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.405 5.56717C10.2995 5.06543 9.89378 4.65981 9.39202 4.55448C8.53454 4.37449 7.77637 5.02717 7.77637 5.85376H8.30231C8.30231 5.32776 8.81045 4.91819 9.3616 5.09015C9.60082 5.16475 9.79533 5.35948 9.86968 5.59882C10.0187 6.0786 9.72752 6.52544 9.3027 6.63288C9.1898 6.66145 9.10573 6.75483 9.10573 6.8713V6.91194C9.10573 7.063 9.24357 7.18479 9.39112 7.1524C10.0754 7.00214 10.5638 6.32314 10.405 5.56717Z",
    fill: "#969696"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3698 5.56717C13.2644 5.06543 12.8586 4.65981 12.3569 4.55448C11.4994 4.37449 10.7412 5.02717 10.7412 5.85376H11.2672C11.2672 5.32776 11.7753 4.91819 12.3264 5.09015C12.5657 5.16475 12.7602 5.35948 12.8345 5.59882C12.9835 6.0786 12.6924 6.52544 12.2675 6.63288C12.1546 6.66145 12.0706 6.75483 12.0706 6.8713V6.91194C12.0706 7.063 12.2084 7.18479 12.356 7.1524C13.0402 7.00214 13.5287 6.32314 13.3698 5.56717Z",
    fill: "#969696"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3346 5.56717C16.2292 5.06543 15.8235 4.65981 15.3217 4.55448C14.4642 4.37449 13.7061 5.02717 13.7061 5.85376H14.232C14.232 5.32776 14.7401 4.91819 15.2913 5.09015C15.5305 5.16475 15.725 5.35948 15.7994 5.59882C15.9484 6.0786 15.6572 6.52544 15.2324 6.63288C15.1195 6.66145 15.0354 6.75483 15.0354 6.8713V6.91194C15.0354 7.063 15.1733 7.18479 15.3208 7.1524C16.0051 7.00214 16.4935 6.32314 16.3346 5.56717Z",
    fill: "#969696"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M19.299 5.56717C19.1936 5.06543 18.7878 4.65981 18.2861 4.55448C17.4286 4.37449 16.6704 5.02717 16.6704 5.85376H17.1964C17.1964 5.32776 17.7045 4.91819 18.2556 5.09015C18.4949 5.16475 18.6894 5.35948 18.7637 5.59882C18.9128 6.0786 18.6216 6.52544 18.1967 6.63288C18.0838 6.66145 17.9998 6.75483 17.9998 6.8713V6.91194C17.9998 7.063 18.1376 7.18479 18.2852 7.1524C18.9694 7.00214 19.4579 6.32314 19.299 5.56717Z",
    fill: "#969696"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2638 5.56717C22.1584 5.06543 21.7527 4.65981 21.2509 4.55448C20.3934 4.37449 19.6353 5.02717 19.6353 5.85376H20.1612C20.1612 5.32776 20.6693 4.91819 21.2205 5.09015C21.4597 5.16475 21.6542 5.35948 21.7286 5.59882C21.8776 6.0786 21.5864 6.52544 21.1616 6.63288C21.0487 6.66145 20.9646 6.75483 20.9646 6.8713V6.91194C20.9646 7.063 21.1025 7.18479 21.25 7.1524C21.9343 7.00214 22.4227 6.32314 22.2638 5.56717Z",
    fill: "#969696"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2287 5.56717C25.1232 5.06543 24.7175 4.65981 24.2157 4.55448C23.3583 4.37449 22.6001 5.02717 22.6001 5.85376H23.126C23.126 5.32776 23.6342 4.91819 24.1853 5.09015C24.4245 5.16475 24.6191 5.35948 24.6934 5.59882C24.8424 6.0786 24.5512 6.52544 24.1264 6.63288C24.0135 6.66145 23.9295 6.75483 23.9295 6.8713V6.91194C23.9295 7.063 24.0673 7.18479 24.2148 7.1524C24.8991 7.00214 25.3875 6.32314 25.2287 5.56717Z",
    fill: "#969696"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1935 5.56717C28.0881 5.06543 27.6824 4.65981 27.1806 4.55448C26.3231 4.37449 25.5649 5.02717 25.5649 5.85376H26.0909C26.0909 5.32776 26.599 4.91819 27.1502 5.09015C27.3894 5.16475 27.5839 5.35948 27.6582 5.59882C27.8073 6.0786 27.5161 6.52544 27.0913 6.63288C26.9784 6.66145 26.8943 6.75483 26.8943 6.8713V6.91194C26.8943 7.063 27.0321 7.18479 27.1797 7.1524C27.864 7.00214 28.3524 6.32314 28.1935 5.56717Z",
    fill: "#969696"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M4.97949 13.1318H8.21949V15.9776H4.97949V13.1318Z",
    fill: "#737AE6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M4.97949 13.1318H8.21949V15.9776H4.97949V13.1318Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6792 13.1318H13.9192V15.9776H10.6792V13.1318Z",
    fill: "#737AE6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6792 13.1318H13.9192V15.9776H10.6792V13.1318Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3789 13.1318H19.6189V15.9776H16.3789V13.1318Z",
    fill: "#737AE6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3789 13.1318H19.6189V15.9776H16.3789V13.1318Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0786 13.1318H25.3186V15.9776H22.0786V13.1318Z",
    fill: "#737AE6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0786 13.1318H25.3186V15.9776H22.0786V13.1318Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7783 13.1318H31.0183V15.9776H27.7783V13.1318Z",
    fill: "#737AE6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7783 13.1318H31.0183V15.9776H27.7783V13.1318Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M4.97949 17.0576H8.21949V19.9034H4.97949V17.0576Z",
    fill: "#737AE6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M4.97949 17.0576H8.21949V19.9034H4.97949V17.0576Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6792 17.0576H13.9192V19.9034H10.6792V17.0576Z",
    fill: "#F2CA52"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6792 17.0576H13.9192V19.9034H10.6792V17.0576Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3789 17.0576H19.6189V19.9034H16.3789V17.0576Z",
    fill: "#737AE6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3789 17.0576H19.6189V19.9034H16.3789V17.0576Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0786 17.0576H25.3186V19.9034H22.0786V17.0576Z",
    fill: "#737AE6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0786 17.0576H25.3186V19.9034H22.0786V17.0576Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7783 17.0576H31.0183V19.9034H27.7783V17.0576Z",
    fill: "#737AE6"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7783 17.0576H31.0183V19.9034H27.7783V17.0576Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M4.97949 20.9834H8.21949V23.8292H4.97949V20.9834Z",
    fill: "#737AE6"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M4.97949 20.9834H8.21949V23.8292H4.97949V20.9834Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6792 20.9834H13.9192V23.8292H10.6792V20.9834Z",
    fill: "#737AE6"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6792 20.9834H13.9192V23.8292H10.6792V20.9834Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3789 20.9834H19.6189V23.8292H16.3789V20.9834Z",
    fill: "#737AE6"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3789 20.9834H19.6189V23.8292H16.3789V20.9834Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0786 20.9834H25.3186V23.8292H22.0786V20.9834Z",
    fill: "#737AE6"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0786 20.9834H25.3186V23.8292H22.0786V20.9834Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7783 20.9834H31.0183V23.8292H27.7783V20.9834Z",
    fill: "#737AE6"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7783 20.9834H31.0183V23.8292H27.7783V20.9834Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M4.97949 24.9092H8.21949V27.755H4.97949V24.9092Z",
    fill: "#737AE6"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M4.97949 24.9092H8.21949V27.755H4.97949V24.9092Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6792 24.9092H13.9192V27.755H10.6792V24.9092Z",
    fill: "#737AE6"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6792 24.9092H13.9192V27.755H10.6792V24.9092Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3789 24.9092H19.6189V27.755H16.3789V24.9092Z",
    fill: "#737AE6"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3789 24.9092H19.6189V27.755H16.3789V24.9092Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0786 24.9092H25.3186V27.755H22.0786V24.9092Z",
    fill: "#F2CA52"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0786 24.9092H25.3186V27.755H22.0786V24.9092Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7783 24.9092H31.0183V27.755H27.7783V24.9092Z",
    fill: "#737AE6"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7783 24.9092H31.0183V27.755H27.7783V24.9092Z",
    fill: "white",
    fillOpacity: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemand);
export default __webpack_public_path__ + "static/media/demand.cbf1d4abb043ba6fff7406e391a01a0f.svg";
export { ForwardRef as ReactComponent };